// extracted by mini-css-extract-plugin
export default {"TableContainer-body":"TableContainer-body38QERFCqhvNE","TableContainer-title":"TableContainer-title2IV0I9o_P29E","TableContainer-text":"TableContainer-text1qyrmmFP3LXz"};